import { SvgIcon, theme } from '@salecycle/ui-component-library';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const ControlCardContainer = styled.div<{ isCardSelected: boolean }>`
  position: relative;
  background: ${({ theme }) => theme.designToken.baseWhite};
  padding: ${({ theme }) => theme.designToken.spacing4};
  margin-bottom: ${({ theme }) => theme.designToken.spacing6};
  outline: ${({ theme, isCardSelected }) => (isCardSelected ? `2px solid ${theme.designToken.primary700}` : 'none')};
  box-shadow: ${({ theme, isCardSelected }) =>
    isCardSelected ? theme.designToken.boxShadow1 : theme.designToken.boxShadow0};

  &:hover {
    outline: ${({ theme, isCardSelected }) =>
      isCardSelected ? `2px solid ${theme.designToken.primary700}` : `1px solid ${theme.designToken.neutral300}`};
  }
`;

const Triangle = styled.div`
  width: 66px;
  height: 66px;
  background: linear-gradient(
    to bottom right,
    #fff 0%,
    #fff 50%,
    ${({ theme }) => theme.designToken.primary700} 50%,
    ${({ theme }) => theme.designToken.primary700} 100%
  );
  position: absolute;
  right: 0;
  bottom: 0;
  svg {
    position: absolute;
    right: 4px;
    bottom: 3px;
  }
`;

export interface ControlCardProps {
  selected?: boolean;
}

export function SelectCard({ selected, children }: PropsWithChildren<ControlCardProps>) {
  return (
    <ControlCardContainer isCardSelected={selected}>
      {children}
      {selected && (
        <Triangle>
          <SvgIcon name="check" size="32" color={theme.designToken.baseWhite} />
        </Triangle>
      )}
    </ControlCardContainer>
  );
}
